import { render } from "./GuildWahl.vue?vue&type=template&id=4a80a7cd"
import script from "./GuildWahl.vue?vue&type=script&lang=js"
export * from "./GuildWahl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__